import script from "./esNotificationSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./esNotificationSettings.vue?vue&type=script&setup=true&lang=ts"

import "./esNotificationSettings.vue?vue&type=style&index=0&id=446ebd6c&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446ebd6c"]])

export default __exports__